import { normalizeIHSVictimData } from './normalizeIHSVictimData'

export const normalizeParentGuardian = (
  data,
  id,
  includeVictimData = false
) => {
  const first_name = data[`parentguardian_first_name_${id}`]
  const middle_name = data[`parentguardian_middle_name_${id}`]
  const last_name = data[`parentguardian_last_name_${id}`]
  const suffix = data[`parentguardian_suffix_${id}`]
  const home_phone = data[`parentguardian_home_phone_${id}`]
  const cell_phone = data[`parentguardian_cell_phone_${id}`]
  const work_phone = data[`parentguardian_work_phone_${id}`]
  const employer = data[`parentguardian_employer_${id}`]
  const employer_phone = data[`parentguardian_employer_phone_${id}`]
  const employer_address = data[`parentguardian_employer_address_${id}`]
  const personal_email = data[`parentguardian_personal_email_${id}`]
  const work_email = data[`parentguardian_work_email_${id}`]
  const address = data[`parentguardian_address_${id}`]
  const job_title = data[`parentguardian_job_title_${id}`]
  const victims = data[`parentguardian_victims_${id}`]

  return !isValidString(first_name) && !isValidString(last_name)
    ? null
    : {
        first_name,
        middle_name,
        last_name,
        suffix,
        email: personal_email,
        phone: cell_phone,
        phone2: home_phone,
        address: address && address.line1Value,
        address2: address && address.line2Value,
        city: address && address.cityValue,
        state: address && address.stateValue,
        zip: address && address.zipValue,
        country: address && address.countryValue,
        employment: {
          employer,
          job_title,
          address: employer_address && employer_address.line1Value,
          address2: employer_address && employer_address.line2Value,
          city: employer_address && employer_address.cityValue,
          state: employer_address && employer_address.stateValue,
          zip: employer_address && employer_address.zipValue,
          country: employer_address && employer_address.countryValue,
          phone: employer_phone,
          phone2: work_phone,
          email: work_email
        },
        victims: includeVictimData
          ? normalizeIHSVictimData(data, 9).filter(v =>
              victims.includes(v.uuid)
            )
          : victims
      }
}

export const isValidString = val => val && val.length > 0

export const normalizeParentGuardianData = (
  data,
  maxIndex = 0,
  index = 0,
  includeVictimData = false
) => {
  let parentguardians = []

  for (let id = index; id <= maxIndex; id++) {
    parentguardians.push(normalizeParentGuardian(data, id, includeVictimData))
  }

  return parentguardians.filter(p => p != null)
}
